<template>
  <LHelpDrawer />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import LHelpDrawer from "@/components/theme/metronic/layout/drawers/HelpDrawer.vue";

export default defineComponent({
  name: "ThemeGlobalDrawers",
  components: {
    LHelpDrawer,
  },
});
</script>
